import { render, staticRenderFns } from "./Solicitudes_aliados_plataforma.vue?vue&type=template&id=6dfd11ea&scoped=true&"
import script from "./Solicitudes_aliados_plataforma.vue?vue&type=script&lang=js&"
export * from "./Solicitudes_aliados_plataforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd11ea",
  null
  
)

export default component.exports